import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import axios from "../../../../../utils/axiosInceptor";

const sendInvoiceRequest = async (pdcIds: string[]) => {
  const url = `${apiV1Endpoint}/booking/sendTorInvoice`;
  const payload = { pdcIds, sendStatus: "sent" };

  const response = await axios.post<ApiResponse>(url, payload);
  return response.data.result;
};

type UseSendInvoiceRequestOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useSendInvoiceRequest = (options: UseSendInvoiceRequestOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: sendInvoiceRequest,
    onSuccess,
    onError,
  });

  return {
    sendInvoiceRequest: mutateAsync,
    isPendingSendInvoiceRequest: isPending,
  };
};
